
const initialState = {
  init: false,
};

function configReducer(state = initialState, action) {
  switch (action.type) {
    case 'INIT':
      return {
        ...state,
        init: true,
      };
    default:
      return state;
  }
}
export default configReducer;



// WEBPACK FOOTER //
// ./src/reducers/config-reducer.js